import React, { Component } from 'react'
import Button from '../../../Components/common/Button'
import SearchField from '../../../Components/common/SearchField'
import { connect } from 'react-redux'
import isEqual from 'react-fast-compare'
import Icon from '@mui/material/Icon'
import DeleteIcon from '@mui/icons-material/Delete';
import { checkPrivileges, errorHandler } from '../../../Helpers'
import ConfirmDialoag from '../../../Components/common/ConfirmDialoag'
import Style from 'style-it'
import Scrollbar from 'react-scrollbars-custom'
import InfiniteScroll from 'react-infinite-scroll-component'
import Loader from '../../Loader'
import { removedNotification } from '../../../Actions/Notifications'
import { ReactComponent as NotificationOff } from '../../../assets/notification-off.svg'
import { ReactComponent as NotificationOn } from '../../../assets/notification-on.svg'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import instance from '../../../axios'
import { notifySuccess } from '../../../Utils/CustomNotifcations'
import withTranslationWrapper from '../../../HOC/withTranslation';

class Notification extends Component {
  constructor (props) {
    super(props)
    this.state = { searchRecently: '' }
  }

  search (e) {
    this.props.searchItems(e.target.value)
  }

  render () {
    const { notification } = this.props

    const notification1 = notification.map(g => (
      <ListRow
        key={g.id}
        item={g}
        editNotificationForm={this.props.editNotificationForm}
        updateNotification={this.props.updateNotification}
      />
    ))

    return (
      <Style>
        {`
					.material-icons {vertical-align: middle; color: inherit}
				`}
        <div className='fms-sidebar sidebar-bg-layer'>
          {checkPrivileges('notification') && (
            <div>
              <div className='section-head section-head-filter' style={{ paddingTop: 0 }}>
                <ul className='filter-row'>
                  <li>
                    <IconButton
                      color='inherit'
                      onClick={e => this.props.history.push('/events')}
                      style={{ padding: 0 }}
                    >
                      <ArrowBackIcon />
                    </IconButton>
                  </li>
                  <li style={{ flex: 1 }}>
                    <SearchField
                      label={this.props.translate('searchNotification')}
                      fullWidth
                      onChange={e => this.search(e)}
                    />
                  </li>
                  <li style={{ paddingTop: 8, paddingBottom: 4 }}>
                    {checkPrivileges('notificationCreate') && (
                      <Button
                        size='small'
                        onClick={e => this.props.openCreateFrom()}
                      >
                        {this.props.translate('sharedCreate')}
                      </Button>
                    )}
                  </li>
                </ul>
              </div>
              <ul className='list-view with-padding-right geofence-sidebar-list'>
                <Scrollbar
                  disableTracksWidthCompensation={true}
                  scrollerProps={{
                    renderer: props => {
                      const { elementRef, ...restProps } = props
                      return (
                        <div
                          {...restProps}
                          ref={elementRef}
                          id='scrollableDiv'
                        />
                      )
                    }
                  }}
                >
                  {this.props.itemPagination ? (
                    <InfiniteScroll
                      dataLength={this.props.itemPagination.items.length}
                      next={this.props.fetchMoreItems}
                      hasMore={this.props.itemPagination.hasNext}
                      loader={<Loader defaultStyle={true} imgSize={50} />}
                      scrollableTarget='scrollableDiv'
                      endMessage={this.props.endMessage}
                    >
                      {notification1}
                    </InfiniteScroll>
                  ) : null}
                </Scrollbar>
              </ul>
            </div>
          )}
        </div>
      </Style>
    )
  }
}

class ListRow1 extends Component {
  constructor (props) {
    super(props)
    this.state = {
      onDeleteConfirmation: false
    }
  }

  onDelete = () => {
    if (this.props.item.id) {
      // fetch(`api/notifications/${this.props.item.id}`, {
      //   method: 'DELETE',
      //   headers: {
      //     Accept: 'application/json',
      //     'Content-Type': 'application/json'
      //   }
      // })
      instance({
        url: `api/notifications/${this.props.item.id}`,
        method: 'DELETE',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        // if (response.ok) {
          this.props.dispatch(removedNotification({ id: this.props.item.id }))
          this.props.dispatch(
            // Notifications.success({
            //   message: this.props.translate('notificationIsDeleted'),
            //   autoDismiss: 10
            // })
            notifySuccess("notificationIsDeleted")
          )
          this.setState({ item: {} })
        // }
        // else{
        //   throw response
        // }
      }).catch(error => {errorHandler(error, this.props.dispatch)})
    }
  }

  shouldComponentUpdate (nextProps, nextState) {
    return !isEqual(nextProps, this.props) || !isEqual(nextState, this.state)
  }

  onRemovedItem = () => {
    this.setState({
      onDeleteConfirmation: true
    })
  }
  onCancel = () => {
    this.setState({
      onDeleteConfirmation: false
    })
  }

  render () {
    return (
      <li className={'list-row clearfix'} key={this.props.item.id}>
        {checkPrivileges('notificationUpdate') && (
          <Tooltip
              classes={{
                popper: 'menu-popper',
                tooltip: 'menu-popper-tooltip'
              }}
              title={this.props.item.id + "   " + this.props.item.name}
            >
            <label
              className='checkbox'
              onClick={e => this.props.editNotificationForm(this.props.item)}
            >
              <span className='unit-name' style={{ fontSize: 12 }}>
                {this.props.item.name}
              </span>
            </label>
          </Tooltip>
        )}
        <div className='callout-actions'>
          {checkPrivileges('notificationDelete') && (
            <span className='action' onClick={this.onRemovedItem}>
              <DeleteIcon className='material-icons'/>
            </span>
          )}
          {checkPrivileges('notificationUpdate') && (
            <Tooltip
              classes={{
                popper: 'menu-popper',
                tooltip: 'menu-popper-tooltip'
              }}
              title={
                this.props.item.attributes&&this.props.item.attributes.suspend
                  ? 'Click here to turn on notification'
                  : 'Click here to turn off notification'
              }
            >
              <span
                className='action'
                onClick={e => this.props.updateNotification(this.props.item)}
              >
                <Icon className='material-icons'>
                  {this.props.item.attributes&&this.props.item.attributes.suspend ? (
                    <NotificationOff />
                  ) : (
                    <NotificationOn />
                  )}
                </Icon>
              </span>
            </Tooltip>
          )}
        </div>

        {this.state.onDeleteConfirmation && (
          <ConfirmDialoag
            onCancel={this.onCancel}
            onOk={this.onDelete}
            title={this.props.translate('areYouWantToDelete')}
            children={this.props.item.name}
          />
        )}
      </li>
    )
  }
}

const mapState = state => ({
  themecolors: state.themeColors
})

const mapStateToProps = connect(mapState)
export const ListRow = mapStateToProps(withTranslationWrapper(ListRow1))
export default mapStateToProps(withTranslationWrapper(Notification))
